module.exports = __webpack_public_path__ + "img/artist_default.d11964fe.jpg";